import { createVuetify } from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { useI18n } from 'vue-i18n'

import i18n from '@/utils/i18n'

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'shoplink',
    themes: {
      shoplink: {
        dark: false,
        colors: {
          primary: '#0f293c',
          secondary: '#5371ff',
          error: '#ff5758',
          success: '#48c774',
          surface: '#f9f9f9',
          background: '#ffffff',
        },
      },
    },
  },
  defaults: {
    VBtn: {
      rounded: true,
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable',
    },
  },
  locale: {
    adapter: createVueI18nAdapter({
      i18n,
      useI18n,
    }),
    rtl: {
      he: true,
    },
  },
})

export default vuetify
